@import '~style-sheet-helpers/core.less';

.item-count {
  justify-content: center;
  font-size: 54px;
  border-radius: 3px;
  width: 65px;
  height: 65px;
  margin: 10px;
  display: flex;
  align-items: center;
}
